import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  spaceId: string | number;
  kitId: string;
  version: number;
};

/**
 * Update the user version of a kit for the current user, i.e. the last version the user has opened.
 */
const [useUpdateKitUserVersion, updateKitUserVersion] = createAsyncAction(
  "kits/updateUserVersion",
  async ({ spaceId, kitId, version }: Args, thunkAPI) => {
    const userId = thunkAPI.getState().user.id;
    const res = await API.call<{ member: string }>({
      endpoint: `kits/${spaceId}/${kitId}/members/${userId}`,
      method: "PUT",
      data: {
        use_version: version,
      },
    });
    return { ...res, result: res.result.member };
  }
);

export default useUpdateKitUserVersion;
export { updateKitUserVersion };
